/* Hafiz Mustafa - kucuk QR kodlayici (byte mode, hata duzeltme M, surum 1-10).
   Sayfadaki [data-hm-qr] ogelerine data-qr-url adresinin QR kodunu SVG olarak cizer. */
(function () {
  'use strict';

  var EXP = new Array(512), LOG = new Array(256);
  (function () {
    var x = 1;
    for (var i = 0; i < 255; i++) { EXP[i] = x; LOG[x] = i; x <<= 1; if (x & 0x100) x ^= 0x11d; }
    for (var j = 255; j < 512; j++) EXP[j] = EXP[j - 255];
  })();
  function carp(a, b) { return (a === 0 || b === 0) ? 0 : EXP[LOG[a] + LOG[b]]; }

  function uretecPolinomu(n) {
    var g = [1];
    for (var i = 0; i < n; i++) {
      var y = new Array(g.length + 1);
      for (var k = 0; k < y.length; k++) y[k] = 0;
      for (var j = 0; j < g.length; j++) { y[j] ^= g[j]; y[j + 1] ^= carp(g[j], EXP[i]); }
      g = y;
    }
    return g;
  }
  function hataKodu(veri, n) {
    var g = uretecPolinomu(n), kalan = new Array(n);
    for (var i = 0; i < n; i++) kalan[i] = 0;
    for (var d = 0; d < veri.length; d++) {
      var f = veri[d] ^ kalan[0];
      kalan.shift(); kalan.push(0);
      if (f !== 0) for (var j = 0; j < n; j++) kalan[j] ^= carp(g[j + 1], f);
    }
    return kalan;
  }

  // [toplam kod sozcugu, blok basina hata kodu, [[blok sayisi, blok basina veri], ...]] - seviye M
  var SURUMLER = {
    1:  [26,  10, [[1, 16]]],
    2:  [44,  16, [[1, 28]]],
    3:  [70,  26, [[1, 44]]],
    4:  [100, 18, [[2, 32]]],
    5:  [134, 24, [[2, 43]]],
    6:  [172, 16, [[4, 27]]],
    7:  [196, 18, [[4, 31]]],
    8:  [242, 22, [[2, 38], [2, 39]]],
    9:  [292, 22, [[3, 36], [2, 37]]]
  };
  var HIZALAMA = {
    1: [], 2: [6, 18], 3: [6, 22], 4: [6, 26], 5: [6, 30],
    6: [6, 34], 7: [6, 22, 38], 8: [6, 24, 42], 9: [6, 26, 46]
  };
  var KALAN_BIT = { 1: 0, 2: 7, 3: 7, 4: 7, 5: 7, 6: 7, 7: 0, 8: 0, 9: 0 };

  function utf8(metin) {
    var s = unescape(encodeURIComponent(metin)), b = [];
    for (var i = 0; i < s.length; i++) b.push(s.charCodeAt(i) & 0xff);
    return b;
  }

  function veriSozcukleri(bayt, surum) {
    var bilgi = SURUMLER[surum], toplamVeri = 0, i, j;
    for (i = 0; i < bilgi[2].length; i++) toplamVeri += bilgi[2][i][0] * bilgi[2][i][1];
    var bit = [];
    function ekle(deger, uzunluk) { for (var k = uzunluk - 1; k >= 0; k--) bit.push((deger >> k) & 1); }
    ekle(4, 4);                       // byte mode
    ekle(bayt.length, 8);             // surum 1-9 icin 8 bit
    for (i = 0; i < bayt.length; i++) ekle(bayt[i], 8);
    var kapasiteBit = toplamVeri * 8;
    for (i = 0; i < 4 && bit.length < kapasiteBit; i++) bit.push(0);
    while (bit.length % 8 !== 0) bit.push(0);
    var sozcuk = [];
    for (i = 0; i < bit.length; i += 8) {
      var v = 0;
      for (j = 0; j < 8; j++) v = (v << 1) | bit[i + j];
      sozcuk.push(v);
    }
    var dolgu = [0xec, 0x11], d = 0;
    while (sozcuk.length < toplamVeri) sozcuk.push(dolgu[d++ % 2]);

    // Bloklara bol, hata kodlarini uret, capraz sirala
    var veriBloklari = [], ecBloklari = [], p = 0;
    for (i = 0; i < bilgi[2].length; i++) {
      for (j = 0; j < bilgi[2][i][0]; j++) {
        var blok = sozcuk.slice(p, p + bilgi[2][i][1]);
        p += bilgi[2][i][1];
        veriBloklari.push(blok);
        ecBloklari.push(hataKodu(blok, bilgi[1]));
      }
    }
    var sonuc = [], enUzun = 0;
    for (i = 0; i < veriBloklari.length; i++) enUzun = Math.max(enUzun, veriBloklari[i].length);
    for (i = 0; i < enUzun; i++)
      for (j = 0; j < veriBloklari.length; j++)
        if (i < veriBloklari[j].length) sonuc.push(veriBloklari[j][i]);
    for (i = 0; i < bilgi[1]; i++)
      for (j = 0; j < ecBloklari.length; j++) sonuc.push(ecBloklari[j][i]);
    return sonuc;
  }

  function surumSec(uzunluk) {
    for (var v = 1; v <= 9; v++) {
      var bilgi = SURUMLER[v], veri = 0;
      for (var i = 0; i < bilgi[2].length; i++) veri += bilgi[2][i][0] * bilgi[2][i][1];
      if (veri * 8 - 12 >= uzunluk * 8) return v;
    }
    return null;
  }

  function bicimBilgisi(maske) {
    var veri = (0 << 3) | maske;          // seviye M = 00
    var kod = veri << 10;
    for (var i = 14; i >= 10; i--) if ((kod >> i) & 1) kod ^= 0x537 << (i - 10);
    return ((veri << 10) | kod) ^ 0x5412;
  }

  function surumBilgisi(surum) {
    var kod = surum << 12;
    for (var i = 17; i >= 12; i--) if ((kod >> i) & 1) kod ^= 0x1f25 << (i - 12);
    return (surum << 12) | kod;
  }

  function maskeUygula(m, satir, sutun) {
    switch (m) {
      case 0: return (satir + sutun) % 2 === 0;
      case 1: return satir % 2 === 0;
      case 2: return sutun % 3 === 0;
      case 3: return (satir + sutun) % 3 === 0;
      case 4: return (Math.floor(satir / 2) + Math.floor(sutun / 3)) % 2 === 0;
      case 5: return ((satir * sutun) % 2) + ((satir * sutun) % 3) === 0;
      case 6: return (((satir * sutun) % 2) + ((satir * sutun) % 3)) % 2 === 0;
      default: return (((satir + sutun) % 2) + ((satir * sutun) % 3)) % 2 === 0;
    }
  }

  function cezaPuani(m) {
    var n = m.length, ceza = 0, i, j, k;
    // 1) ardisik ayni renk
    for (i = 0; i < n; i++) {
      for (var yon = 0; yon < 2; yon++) {
        var say = 1, onceki = yon ? m[0][i] : m[i][0];
        for (j = 1; j < n; j++) {
          var h = yon ? m[j][i] : m[i][j];
          if (h === onceki) { say++; } else { if (say >= 5) ceza += say - 2; say = 1; onceki = h; }
        }
        if (say >= 5) ceza += say - 2;
      }
    }
    // 2) 2x2 bloklar
    for (i = 0; i < n - 1; i++) for (j = 0; j < n - 1; j++)
      if (m[i][j] === m[i + 1][j] && m[i][j] === m[i][j + 1] && m[i][j] === m[i + 1][j + 1]) ceza += 3;
    // 3) 1:1:3:1:1 deseni
    var desen1 = [1, 0, 1, 1, 1, 0, 1, 0, 0, 0, 0], desen2 = [0, 0, 0, 0, 1, 0, 1, 1, 1, 0, 1];
    for (i = 0; i < n; i++) for (j = 0; j < n - 10; j++) {
      var e1 = true, e2 = true, d1 = true, d2 = true;
      for (k = 0; k < 11; k++) {
        var y = m[i][j + k] ? 1 : 0, d = m[j + k][i] ? 1 : 0;
        if (y !== desen1[k]) e1 = false;
        if (y !== desen2[k]) e2 = false;
        if (d !== desen1[k]) d1 = false;
        if (d !== desen2[k]) d2 = false;
      }
      if (e1 || e2) ceza += 40;
      if (d1 || d2) ceza += 40;
    }
    // 4) koyu oran
    var koyu = 0;
    for (i = 0; i < n; i++) for (j = 0; j < n; j++) if (m[i][j]) koyu++;
    var oran = (koyu * 100) / (n * n);
    ceza += Math.floor(Math.abs(oran - 50) / 5) * 10;
    return ceza;
  }

  function matrisKur(surum, sozcukler, maske) {
    var n = surum * 4 + 17, i, j, r, c;
    var m = [], ayrilmis = [];
    for (i = 0; i < n; i++) { m.push(new Array(n).fill(false)); ayrilmis.push(new Array(n).fill(false)); }

    function konum(satir, sutun) {
      for (r = -1; r <= 7; r++) for (c = -1; c <= 7; c++) {
        var y = satir + r, x = sutun + c;
        if (y < 0 || y >= n || x < 0 || x >= n) continue;
        var koyu = (r >= 0 && r <= 6 && (c === 0 || c === 6)) ||
                   (c >= 0 && c <= 6 && (r === 0 || r === 6)) ||
                   (r >= 2 && r <= 4 && c >= 2 && c <= 4);
        m[y][x] = koyu; ayrilmis[y][x] = true;
      }
    }
    konum(0, 0); konum(0, n - 7); konum(n - 7, 0);

    // zamanlama
    for (i = 8; i < n - 8; i++) { m[6][i] = i % 2 === 0; ayrilmis[6][i] = true; m[i][6] = i % 2 === 0; ayrilmis[i][6] = true; }

    // hizalama
    var merkez = HIZALAMA[surum];
    for (i = 0; i < merkez.length; i++) for (j = 0; j < merkez.length; j++) {
      var cy = merkez[i], cx = merkez[j];
      if ((cy <= 8 && cx <= 8) || (cy <= 8 && cx >= n - 9) || (cy >= n - 9 && cx <= 8)) continue;
      for (r = -2; r <= 2; r++) for (c = -2; c <= 2; c++) {
        m[cy + r][cx + c] = (Math.abs(r) === 2 || Math.abs(c) === 2 || (r === 0 && c === 0));
        ayrilmis[cy + r][cx + c] = true;
      }
    }

    // surum bilgisi alanlari (surum 7 ve ustu)
    if (surum >= 7) {
      var sb = surumBilgisi(surum);
      for (i = 0; i < 18; i++) {
        var vb = ((sb >> i) & 1) === 1;
        var vy = Math.floor(i / 3), vx = (i % 3) + n - 11;
        m[vy][vx] = vb; ayrilmis[vy][vx] = true;
        m[vx][vy] = vb; ayrilmis[vx][vy] = true;
      }
    }

    // bicim alanlari + sabit koyu modul
    for (i = 0; i < 9; i++) { ayrilmis[8][i] = true; ayrilmis[i][8] = true; }
    for (i = 0; i < 8; i++) { ayrilmis[8][n - 1 - i] = true; ayrilmis[n - 1 - i][8] = true; }
    m[n - 8][8] = true; ayrilmis[n - 8][8] = true;

    // veri yerlesimi (zikzak)
    var bit = [];
    for (i = 0; i < sozcukler.length; i++) for (j = 7; j >= 0; j--) bit.push((sozcukler[i] >> j) & 1);
    for (i = 0; i < KALAN_BIT[surum]; i++) bit.push(0);
    var indeks = 0, yukari = true;
    for (var sutun = n - 1; sutun > 0; sutun -= 2) {
      if (sutun === 6) sutun--;
      for (var adim = 0; adim < n; adim++) {
        var satir = yukari ? n - 1 - adim : adim;
        for (var s = 0; s < 2; s++) {
          var x = sutun - s;
          if (ayrilmis[satir][x]) continue;
          var deger = indeks < bit.length ? bit[indeks++] === 1 : false;
          if (maskeUygula(maske, satir, x)) deger = !deger;
          m[satir][x] = deger;
        }
      }
      yukari = !yukari;
    }

    // bicim bilgisi
    var bicim = bicimBilgisi(maske);
    for (i = 0; i < 15; i++) {
      var b = ((bicim >> i) & 1) === 1;
      // dikey serit: sol ust sutun 8 ve sol alt kose
      if (i < 6) m[i][8] = b;
      else if (i < 8) m[i + 1][8] = b;
      else m[n - 15 + i][8] = b;
      // yatay serit: sag ust ve sol ust satir 8
      if (i < 8) m[8][n - 1 - i] = b;
      else if (i < 9) m[8][15 - i] = b;
      else m[8][14 - i] = b;
    }
    return m;
  }

  function qrMatris(metin) {
    var bayt = utf8(metin), surum = surumSec(bayt.length);
    if (!surum) return null;
    var sozcukler = veriSozcukleri(bayt, surum), enIyi = null, enIyiCeza = Infinity;
    for (var maske = 0; maske < 8; maske++) {
      var m = matrisKur(surum, sozcukler, maske), c = cezaPuani(m);
      if (c < enIyiCeza) { enIyiCeza = c; enIyi = m; }
    }
    return enIyi;
  }

  function qrSvg(metin, secenek) {
    secenek = secenek || {};
    var m = qrMatris(metin);
    if (!m) return '';
    var n = m.length, cerceve = secenek.quiet == null ? 2 : secenek.quiet, boy = n + cerceve * 2;
    var yol = '';
    for (var i = 0; i < n; i++) {
      var j = 0;
      while (j < n) {
        if (!m[i][j]) { j++; continue; }
        var basla = j;
        while (j < n && m[i][j]) j++;
        yol += 'M' + (basla + cerceve) + ' ' + (i + cerceve) + 'h' + (j - basla) + 'v1h-' + (j - basla) + 'z';
      }
    }
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + boy + ' ' + boy + '" shape-rendering="crispEdges" role="img" aria-label="' +
      (secenek.alt || 'QR kod') + '">' +
      '<rect width="' + boy + '" height="' + boy + '" fill="' + (secenek.bg || '#ffffff') + '"/>' +
      '<path d="' + yol + '" fill="' + (secenek.fg || '#000000') + '"/></svg>';
  }

  function ciz(kok) {
    (kok || document).querySelectorAll('[data-hm-qr]:not([data-hm-qr-hazir])').forEach(function (el) {
      var adres = el.getAttribute('data-qr-url');
      if (!adres) return;
      var svg = qrSvg(adres, {
        fg: el.getAttribute('data-qr-fg') || '#1a1a1a',
        bg: el.getAttribute('data-qr-bg') || '#ffffff',
        alt: el.getAttribute('data-qr-alt') || 'QR kod'
      });
      if (!svg) return;
      el.innerHTML = svg;
      el.setAttribute('data-hm-qr-hazir', '1');
    });
  }

  window.HMQr = { svg: qrSvg, matris: qrMatris, ciz: ciz };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { ciz(); });
  else ciz();
  document.addEventListener('shopify:section:load', function (e) { ciz(e.target); });
})();
